<template>
  <AppView
    padd-bottom
  >
    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <CompanyHeader :company="company" :loading="loadingCompany" />
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany || error || errorCompanyProgram" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany || error || errorCompanyProgram"></p>
      </div>

      <div v-else-if="loadingCompany || loadingCompanyProgram || loading" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <transition name="fade" mode="out-in" appear>
          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <portal to="modal-body" key="mdl">
                <transition
                  name="fade"
                  mode="out-in"
                  appear
                  :key="activeModalComponent"
                >
                  <component
                    :is="activeModalComponent"
                    v-bind="activeModalComponentOptions.props"
                    :class="['tw-p-6']"
                    @created-success="closeModal(); getProgramSurveys();"
                  />
                </transition>
              </portal>

              <div class="tw-flex tw-items-center">
                <UserPhoto
                  :photo="activeCompanyProgram.logo"
                  :user-name="{
                    name: activeCompanyProgram.name,
                  }"
                  logo
                  photo-size="tw-h-10 tw-w-10"
                  :class="[
                    'tw-rounded-10--force --force-children tw-bg-app-white-87 tw-mx-2',
                    { 'tw-shadow-app-sm': !(activeCompanyProgram.logo || '').length }
                  ]"
                />

                <p class="tw-font-bold">
                  {{ activeCompanyProgram.name }} Mentorship Program
                </p>
              </div>

              <template v-if="isSuperAdmin && surveys.length">
                <div class="tw-bg-gray-200 tw-rounded-10 tw-mb-4 tw-p-4">
                  <p class="tw-text-sm tw-mb-4 tw-uppercase tw-font-bold opacity-54">
                    Program Surveys
                  </p>

                  <div class="tw-flex tw-items-center tw-w-full">
                    <div v-for="survey in surveys" :key="survey.id" class="tw-w-1/3 tw-p-4 tw-bg-gray-300 tw-rounded-3">
                      <p class="tw-mb-2 font-title tw-text-lg tw-tracking-wider">
                        {{ survey.name }}
                      </p>
                      <BaseButton
                        text="Edit"
                        @click="promptEdit('survey', {surveyId: survey.id})"
                      />
                    </div>
                  </div>
                </div>
              </template>

              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-3">
                  <img
                    data-src="/img/company-surveys.png"
                    src="/img/company-surveys.png"
                    style="width: 80px; height: 80px;"
                    class="tw-object-cover tw-block tw-mr-8"
                    async
                  >
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Surveys
                  </h3>

                  <div class="tw-flex-grow"></div>

                  <BaseButton
                    type="button"
                    text="Create a Survey"
                    @click="promptEdit('survey')"
                    v-if="isSuperAdmin && !surveys.length"
                  />
                  <BaseButton
                    type="button"
                    text="Create a Survey Context"
                    @click="promptEdit('surveyType')"
                    v-if="isSuperAdmin"
                  />
                  <BaseButton
                    class="tw-ml-3"
                    type="button"
                    text="Add a question"
                    v-if="activeSurvey"
                    @click="promptEdit('surveyQuestion')"
                  />
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-6"></div>
                <template v-if="surveys.length">
                  <div class="tw-flex tw-items-start tw-flex-wrap">
                    <!-- list of questions -->
                    <template v-for="(questionTypeId, index) in Object.keys(surveyQuestions)">
                      <Accordion :key="index" :offset-body="false">
                        <template v-slot:header>
                          <div class="tw-flex tw-p-3">
                            <!-- <div class="tw-w-2/3 tw-pr-3"> -->
                            <div class=" tw-pr-3">
                              <h3 class="tw-text-xl tw-mb-2 tw-font-bold">{{surveyQuestions[questionTypeId][0]?.surveyType?.name}}</h3>
                              <div class="tw-flex tw-items-center">
                                <BaseButton
                                  v-if="isSuperAdmin"
                                  text="Edit"
                                  @click="promptEdit('surveyType', { surveyTypeId: surveyQuestions[questionTypeId][0]?.surveyType?.id })"
                                  class="tw-mb-4 tw-py-0 tw-px-3 tw-mr-3"
                                />
                                <BaseButton
                                  :to="{name: 'companyProgramSurveyResponses', params: { id, programId, questionTypeId }}"
                                  text="View Responses"
                                  class="tw-mb-4 tw-py-0 tw-px-3 tw-mr-3 tw-bg-app-primary-blue tw-text-white tw-border-0"
                                />
                              </div>
                            </div>
                            <!-- <div class="tw-w-1/3 tw-pl-3 tw-text-right"> -->
                              <!-- switch input for activating/deactivating survey -->
                              <!-- [update] no need for the input -->
                              <!-- <SwitchInput :checked="Boolean(Number(survey.status))" @change="toggleActivateSurvey(survey.id, ...arguments)" /> -->
                            <!-- </div> -->
                          </div>
                        </template>
                        <template v-slot:body>
                          <div class="tw-bg-gray-200 tw-p-3">
                            <p class="tw-text-sm opacity-54">Survey Questions</p>
                            <div class="tw-border-t tw-border-app-black-11 tw-mt-1 tw-mb-3"></div>

                            <template v-if="(surveyQuestions[questionTypeId] || []).length">

                              <div class="tw-flex tw-mb-1 opacity-54">
                                <p class="tw-w-1/2">Questions</p>
                                <p class="tw-w-1/2">Ratings/Choices</p>
                              </div>

                              <!-- list of survey questions -->
                              <template v-for="(question, questionIndex) in (surveyQuestions[questionTypeId] || [])">
                                <div :key="questionIndex" class="tw-bg-gray-300 tw-mb-3 tw-rounded-3 tw-p-2">
                                  <div class="tw-flex">
                                    <div class="tw-w-1/2 tw-pr-4 tw-border-r tw-border-black tw-mr-4">
                                      <p class="tw-text-base tw-mb-1">{{question.question}} ({{question.type.q_type}})</p>
                                      <!-- switch input for activating/deactivating questions -->
                                      <div class="tw-flex tw-items-center tw-mb-1">
                                        <SwitchInput
                                          :checked="Number(question.status) === 0"
                                          @change="toggleActivateSurveyQuestion(question.id, ...arguments)"
                                          size="sm"
                                        />
                                        <span v-if="Number(question.status) === 0" class="tw-pl-2 tw-text-sm opacity-54">Activated</span>
                                        <span v-if="Number(question.status) === 2" class="tw-pl-2 tw-text-sm opacity-54">Deactivated</span>
                                      </div>
                                      <BaseButton
                                        text="Edit"
                                        @click="promptEdit('surveyQuestion', {questionId: question.id, questionTypeId})"
                                        class="tw-mb-4 tw-py-0 tw-px-3"
                                      />
                                    </div>
                                    <div>
                                        <!-- list of ratings -->
                                        <p v-for="(rating, ratingIndex) in (question.ratings || [])" :key="ratingIndex" class="tw-text-sm tw-mb-2">
                                          - {{rating.ratings}}
                                          <BaseButton
                                            text="Edit"
                                            @click="promptEdit('questionRatings', {questionId: question.id, ratingId: rating.id})"
                                            class="tw-py-0 tw-px-3 tw-mr-1"
                                          />
                                        </p>

                                        <p class="tw-text-sm tw-mb-1 tw-italic" v-if="(question.ratings || []).length == 0">
                                          <!-- A question without ratings is a text response question type -->
                                        </p>

                                        <BaseButton
                                          text="Create a rating/choice"
                                          @click="promptEdit('questionRatings', {questionId: question.id})"
                                          :class="[
                                            'tw-mt-4 transition-fast',
                                            {'tw-opacity-25 hover:tw-opacity-100': (question.ratings || []).length == 0}
                                            ]"
                                        />
                                    </div>
                                  </div>
                                </div>
                              </template>

                              <!-- <BaseButton text="Create a question" @click="promptEdit('surveyQuestion', {})" /> -->
                            </template>
                            <template v-else>
                              <!-- <BaseButton text="Create a question" @click="promptEdit('surveyQuestion', {})" /> -->
                            </template>
                          </div>
                        </template>
                      </Accordion>
                      <!-- <div
                        :key="index"
                        class="tw-p-4 tw-bg-gray-200 tw-mx-4 tw-mb-4 tw-rounded-10 tw-w-full"
                      >
                      </div> -->
                    </template>

                    <!-- <div v-if="!surveys.length" class="tw-text-center tw-text-base tw-py-12">
                      No surveys found
                    </div> -->
                  </div>
                </template>
              </template>

            </div>
          </div>
        </transition>
      </div>

    </transition>

  </AppView>
</template>

<script>
import CompanyHeader from '@/views/Companies/Company/_partials/CompanyHeader.vue';
import EditProgramSurvey from '@/views/Companies/Company/_partials/EditProgramSurvey.vue';
import EditProgramSurveyType from '@/views/Companies/Company/_partials/EditProgramSurveyType.vue';
import EditProgramSurveyQuestion from '@/views/Companies/Company/_partials/EditProgramSurveyQuestion.vue';
import EditProgramQuestionRatings from '@/views/Companies/Company/_partials/EditProgramQuestionRatings.vue';
import SwitchInput from '@/components/SwitchInput.vue';
import Accordion from '@/components/Accordion.vue';
import UserPhoto from '@/components/UserPhoto.vue';

import companyProgramMixin from '@/mixins/companyProgram';
import companyMixin from '@/mixins/company';

export default {
  name: 'CompanySurveys',
  components: {
    CompanyHeader,
    EditProgramSurvey,
    EditProgramSurveyType,
    EditProgramSurveyQuestion,
    EditProgramQuestionRatings,
    SwitchInput,
    Accordion,
    UserPhoto,
  },
  mixins: [companyMixin, companyProgramMixin],
  props: ['id', 'programId'],
  data() {
    return {
      error: undefined,
      loading: true,
      surveys: [],
      surveyQuestions: {},
      modalComponents: {
        survey: {
          component: 'EditProgramSurvey',
        },
        surveyType: {
          component: 'EditProgramSurveyType',
        },
        surveyQuestion: {
          component: 'EditProgramSurveyQuestion',
        },
        questionRatings: {
          component: 'EditProgramQuestionRatings',
        },
      },
      // active modal components (forms)
      activeModalComponent: false,
      activeModalComponentOptions: {
        props: {},
      },
    };
  },
  computed: {
    activeSurvey() {
      return this.surveys[0];
    },
  },
  methods: {
    // gets the survey
    async getProgramSurveys() {
      this.loading = true;
      this.error = undefined;

      const surveys = await this.$store.dispatch('getCompanyProgramSurveys', [this.activeCompanyProgram.id, true]);

      if ((!surveys || (Array.isArray(surveys) && !surveys.length)) && !this.isSuperAdmin) {
        // error in getting surveys
        this.error = 'Could not get surveys. Please contact support';

        return false;
      }

      this.surveys = surveys;

      await this.getProgramSurveyQuestions();

      this.loading = false;

      return surveys;
    },

    async getProgramSurveyQuestions() {
      const surveyQuestions = await this.$store.dispatch('getProgramSurveyQuestions', [this.activeCompanyProgram.id, true]);

      if (!surveyQuestions) {
        this.error = 'Could not get surveys questions. Please try again later';

        return false;
      }

      this.surveyQuestions = surveyQuestions;

      await this.$nextTick();

      return true;
    },
    // opens the right modal component
    async promptEdit(componentName, props = {}) {
      const allProps = {
        company: this.company,
        companyProgram: this.activeCompanyProgram,
        surveyId: this.activeSurvey?.id,
        ...props,
      };

      this.activeModalComponentOptions.props = { ...allProps };
      this.activeModalComponent = this.modalComponents[componentName].component;

      await this.$nextTick();

      // openModal
      this.$store.commit('openModal', [true, 'modal']);
    },
    async toggleActivateSurvey(surveyId, activate) {
      let result;
      if (activate) {
        result = await this.$store.dispatch('activateSurvey', surveyId);
      } else {
        result = await this.$store.dispatch('deactivateSurvey', surveyId);
      }

      if (result) {
        this.$toasted.success(
          activate ? 'Activated successfully!' : 'Deactivated successfully',
          { duration: 1500 },
        );

        this.getSurveys();
      } else {
        this.$toasted.global.appError();
      }
    },
    async toggleActivateSurveyQuestion(questionId, activate) {
      let result;
      if (activate) {
        result = await this.$store.dispatch('activateProgramSurveyQuestion', questionId);
      } else {
        result = await this.$store.dispatch('deactivateProgramSurveyQuestion', questionId);
      }

      if (result) {
        this.$toasted.success(
          activate ? 'Activated successfully!' : 'Deactivated successfully',
          { duration: 1500 },
        );

        this.getProgramSurveys();

        if (activate) {
          this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.activateSurveyQuestion);
        } else {
          this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.deactivateSurveyQuestion);
        }
      } else {
        this.$toasted.global.appError();
      }
    },
  },
  async created() {
    // get company
    await this.getCompany();
    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyProgram();

    if (!this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await Promise.all([
      this.getProgramSurveys(),
    ]);

    await this.$nextTick();
    await this.$nextTick();

    return true;
  },
};
</script>

<style>

</style>
